import React from 'react';
import FooterBrand from './FooterBrand';
import ContactInfo from './ContactInfo';
import FooterLinks from './FooterLinks';
import SocialMedia from './SocialMedia';

/**
 * Mobile Footer Component
 * Displays footer content optimized for mobile screens
 * 
 * @param {Object} data - Footer data objectm
 * @param {Boolean} isDarkMode - Dark mode state
 * @param {String} className - Additional CSS classes
 */
const MobileFooter = ({ data, isDarkMode, className = '' }) => {
    if (!data) return null;

    return (
        <footer className={`d-block d-md-none ${className}`} style={{
            backgroundColor: isDarkMode ? '#1a1a1a' : '#16110d',
            transition: 'background-color 0.3s ease',
            borderTop: `1px solid ${isDarkMode ? '#333' : '#444'}`
        }}>
            <div className="container py-4">
                {/* Logo and Description */}
                <FooterBrand 
                    footerIcon={data.footerIcon}
                    description={data.FooterDescription}
                    isDarkMode={isDarkMode}
                    isMobile={true}
                />

                {/* Contact Information */}
                <div className="mb-4">
                    <ContactInfo 
                        addresses={data.Address}
                        isDarkMode={isDarkMode}
                    />
                </div>

                {/* Services Links */}
                {data.LeftBottomLinks && data.LeftBottomLinks.filter(link => !link.isHidden).length > 0 && (
                    <div className="mb-4">
                        <div className="row g-2">
                            {data.LeftBottomLinks
                                ?.filter(link => !link.isHidden)
                                .map((link, index) => (
                                    <div key={index} className="col-6">
                                        <FooterLinks 
                                            links={[link]} 
                                            className=""
                                            linkClassName=""
                                        />
                                    </div>
                                ))}
                        </div>
                    </div>
                )}

                {/* Legal Links */}
                {data.rightBottomLinks && data.rightBottomLinks.filter(link => !link.isHidden).length > 0 && (
                    <div className="mb-4">
                        <div className="row g-2">
                            {data.rightBottomLinks
                                ?.filter(link => !link.isHidden)
                                .map((link, index) => (
                                    <div key={index} className="col-6">
                                        <FooterLinks 
                                            links={[link]} 
                                            className=""
                                            linkClassName=""
                                        />
                                    </div>
                                ))}
                        </div>
                    </div>
                )}

                {/* Social Media */}
                {data.socialIcons && data.socialIcons.length > 0 && (
                    <div className="mb-4 text-center">
                        <SocialMedia 
                            socialIcons={data.socialIcons}
                            isDarkMode={isDarkMode}
                            isMobile={true}
                        />
                    </div>
                )}

                {/* Footer Bottom */}
                <div style={{
                    borderTop: `1px solid ${isDarkMode ? '#333' : '#444'}`,
                    paddingTop: '1.5rem',
                    marginTop: '1.5rem'
                }}>
                    <p style={{
                        color: '#888',
                        fontSize: '13px',
                        margin: '0',
                        textAlign: 'center',
                        lineHeight: '1.4'
                    }}>
                        {data.Copyrights || `© ${new Date().getFullYear()} HireGo. All Rights Reserved.`}
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default MobileFooter;
